import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { device } from '../utils/Brekapoints';

const StaffListStyles = styled.div`
  display: flex;
  flex-direction: column;

  @media ${device.mobile} {
    align-items: center;
  }

  .gatsby-image-wrapper {
    border: 1px solid var(--grey);
    margin-bottom: 20px;
    height: 208px;
    width: 208px;
  }
`;

const StaffItem = styled.div`
  display: flex;
  flex-direction: column;

  @media ${device.mobile} {
    text-align: center;
  }
`;

const StaffName = styled.span`
  font-weight: bold;
  color: var(--blue);
  font-size: 2rem;

  @media ${device.mobile} {
    text-align: center;
  }
`;

export default function StaffList({ staff, defaultImage, includeDivision }) {
  const callsign = staff.displayCallsign
    ? staff.displayCallsign
    : staff.callsign;
  return (
    <StaffListStyles>
      <GatsbyImage
        image={
          !staff.image || !staff.image.asset
            ? defaultImage[0].staffImage.asset.gatsbyImageData
            : staff.image.asset.gatsbyImageData
        }
        alt={staff.name}
      />
      <StaffItem>
        <StaffName>
          {staff.name}
          {callsign === 'N/A' ? '' : ` - (${callsign})`}
        </StaffName>
        <div>
          {staff.rank.name}
          {(staff.division || staff.displayDivision) && includeDivision ? (
            <div>
              {staff.displayDivision
                ? staff.displayDivision
                : staff.division.name}
            </div>
          ) : (
            ''
          )}
        </div>
      </StaffItem>
    </StaffListStyles>
  );
}
